export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Appearance-Gray-9b49f2faa5026e45e2a55604051616b5.svg";